import { AppProviders } from '@/app/providers/AppProviders'

export default function App() {
  return <AppProviders />
}
